import React from 'react';

const AnonymousPage = () => {
  return (
    <div>
      <h1>Anonymous Page</h1>
    </div>
  );
};

export default AnonymousPage;



// WEBPACK FOOTER //
// ./components/AnonymousPage.jsx